export default __webpack_public_path__ + "static/media/bitmap@3x.e925a61d.jpg";